<template>
  <gg-card>
    <gg-card-header>
      Federal Trade Commission Guidelines
    </gg-card-header>
    <gg-card-text>
      <v-row>
        <v-col cols="12">
          <p> GreenGeeks requires that each affiliate comply with the rules and guidelines expressed by the FTC (Federal Trade
            Commission) and that failure to do so may result in removal from our affiliate program and cancellation of
            commissions. In December 2009 the FTC released guidelines which require transparency by any affiliate who uses
            reviews, rankings or testimonials to promote products or services which would disclose the fact to website
            visitors that the affiliate is compensated for their reviews, rankings or testimonials.</p>

          <p>Please read the FTC’s: <a href="http://www.ftc.gov/os/2009/10/091005revisedendorsementguides.pdf">Guides
            Concerning the Use of Endorsements and Testimonials in Advertising.</a></p>

          <p><b><u>As an affiliate, how can you comply with the FTC’s rules?</u></b></p>
          <p>To comply with the FTC rules you should meet four basic requirements regarding your disclosure to your website
            visitors that you may receive compensation for your reviews, recommendations, rankings, etc.. Your disclosures
            should be frequent, clear, conspicuous and require no additional scrolling or other type of action (like hovering)
            to be able to see the disclosure.</p>
          <div class="row">
            <div class="col-sm-6">
              <ol>
                <li>The FTC advises that your disclosure should be on any page that has a review, recommendation, comment or
                  article that promotes any product or service for which you receive an affiliate commission.
                </li>
                <br>
                <li>The FTC further advises that it should be clear to the reader that as an affiliate you may receive
                  compensation for your reviews, recommendations, rankings, etc.
                </li>
                <br>
                <li>The disclosure should be in text which is at least as large as the other text on your website page and
                  should be in contrast with both the background of the website page and with the other text on that page. So
                  for example if your website page background is white and your text is black, you should use a dark color
                  (other than and distinctive compared to Black Text) like bright blue for your disclosure’s text.
                </li>
                <br>
                <li>The disclosure should also start with the word “Disclosure” and it should require no scrolling or any
                  other type of user action to have the disclosure be immediately evident to your website visitor.
                </li>
              </ol>
            </div>

            <div class="col-sm-6">
              <div class="box">
                <div class="box-content">
                  <blockquote style="font-size: 13px;">
                    <p><b><u>Example Disclosure:</u></b></p>
                    <p style="color: #2196f3!important">
                      Disclosure: This website is independently owned and operated. We are a professional review website which
                      receives compensation from the companies whose products and/or services we review. We tested and
                      reviewed the web hosting sites ranked here and the opinions expressed here are our own.
                    </p>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>

          <p><b><u>Additional Resources</u></b></p>
          <p>If you have further questions regarding the FTC rules and your website you should consult with a legal advisor
            AND you may learn more from the FTC with their helpful guideline articles and information below:</p>

          <div class="row">
            <div class="col-sm-12">
              <ul>
                <li><a href="http://www.ftc.gov/os/2009/10/091005revisedendorsementguides.pdf">Guides Concerning the Use of
                  Endorsements and Testimonials in Advertising</a></li>
                <li><a
                  href="http://business.ftc.gov/documents/bus71-ftcs-revised-endorsement-guideswhat-people-are-asking.pdf">The
                  FTC’s Revised Endorsement Guides: What People are Asking</a></li>
                <li><a href="http://www.ftc.gov/bcp/edu/pubs/business/ecommerce/bus41.pdf">Dot Com Disclosures: Information
                  About Online Advertising</a></li>
              </ul>
            </div>
          </div>

          <p><b>Please Note:</b> The information provided on this website page is intended as guidance only and is not
            intended as legal advice. Should you need more legal advice regarding how these rules pertain to your website you
            should seek a legal advisor.</p>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
export default {
  name: 'AffiliatesLegalFtc',
}
</script>

<style>
.active-legal-tab {
  background: #0CA750;
  color: white !important;
}
</style>
